import React, {useEffect, useState} from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import {useParams} from 'react-router-dom';
import "react-datepicker/dist/react-datepicker.css";
import {baseUrl, formatDateTime, ipAddress, userLocation, userName} from '../Univ.js'
function ConfirmIpAdmit() {
    const {ip_id} = useParams();
    const [ipData, setIpData] = useState([]);
    useEffect(() => {
        fetchIpData();
    }, []);
    function fetchIpData() {
        axios.get(baseUrl + "edit-ip-admit/" + ip_id + '/')
            .then(response => {
                setIpData([response.data]);
            })
            .catch(error => {
                console.log(error);
            });
    }
    const handleFormSubmit = (e) => {
        e.preventDefault();
        const _formData = new FormData();
        const room_no = (ipData[0].room_no.id);
        _formData.append('status', '2');
        axios.post(baseUrl + "update-ip-admit/" + ip_id + '/', _formData)
            .then(response => {
                if (response.status == 200 || response.status == 201) {
                    _formData.append('status', 0);
                    _formData.append('ip_add', ipAddress);
                    _formData.append('location', userLocation);
                    axios.put(`${baseUrl}edit-room-no/${room_no}/`, _formData)
                        .then(response1 => {
                            _formData.append('ip', ip_id);
                            _formData.append('tot_invoiced', 0);
                            _formData.append('tot_paid', 0);
                            _formData.append('tot_balance', 0);
                            _formData.append('tot_used', 0);
                            _formData.append('remain_balance', 0);
                            _formData.append('tot_disc', 0);
                            _formData.append('tot_refund', 0);
                            _formData.append('tot_due', 0);
                            _formData.append('status', '1');
                            _formData.append('addedby', userName);
                            _formData.append('ip_add', ipAddress);
                            _formData.append('location', userLocation);
                            axios.post(baseUrl + "ip-tot/", _formData)
                                .then(response => {
                                    Swal.fire({
                                        title: 'Admission Confirmed Successfully',
                                        icon: 'success',
                                        timer: 2000,
                                        showConfirmButton: false
                                    });
                                });
                        });
                    setTimeout(() => {
                        window.location.href = '/ip-list/';
                    }, 2000);
                }
            })
            .catch(error => {
                console.log(error);
                Swal.fire(
                    'Error!',
                    'Failed. Please try again later.',
                    'error'
                );
            });
    };
    const handleDelete = (id) => {
    Swal.fire({
        title: 'Confirm',
        text: 'Are you Sure you want to Cancel this',
        icon: 'info',
        confirmButtonText: 'Continue',
        showCancelButton: true,
    }).then(async (result) => {
        if (!result.isConfirmed) {
            Swal.fire('info', 'Data has not been deleted');
            return;
        }

        try {
            const response = await axios.delete(
                `${baseUrl}edit-ip-admit/${id}/`
            );

            Swal.fire('success', 'IP Admission is Canceled');

            setTimeout(() => {
                window.location.href = '/ip-list/';
            }, 2000);
        } catch (error) {
            console.error(
                'IP admission delete error:',
                error.response?.status,
                error.response?.data || error.message
            );

            Swal.fire(
                'error',
                error.response?.data?.detail ||
                'IP admission could not be canceled. Check the console and Django terminal.'
            );
        }
    });
};
    return (
        <section className="container mt-4">
            <div className="table-responsive">
                <table className="erp-table-modern">
                    <thead>
                    <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                        <th>Patient</th>
                        <th>Patient ID</th>
                        <th>Patient Name</th>
                        <th>Gender</th>
                        <th>D.O.B/Age</th>
                        <th>Mobile</th>
                        <th>Admited On</th>
                        <th>Primary Consultant</th>
                        <th>Confirm</th>
                        <th>Cancel</th>
                    </tr>
                    </thead>

                    <tbody>
                    {ipData.map((patientData, index) => (
                        <tr>
                            <td><img src={patientData.profile_pic} alt="Thumbnail" className="thumbnail"
                                     style={{width: 120, height: 60}}/></td>
                            <td>{patientData.pat.pat_id}</td>
                            <td>{patientData.pat.patient}</td>
                            <td>{patientData.pat.gender}</td>
                            <td>{patientData.pat.age}</td>
                            <td>{patientData.pat.mobile}</td>
                            <td>{formatDateTime(patientData.admit_date)}</td>
                            <td>{patientData.primary_consult.consultant}</td>
                            <td>
                                <form onSubmit={handleFormSubmit}>
                                    <button type="submit" className="btn btn-warning ms-1">
                                        Confirm Admission
                                    </button>
                                </form>
                            </td>
                            <td>
                                <button onClick={() => handleDelete(patientData.id)}
                                        className="btn btn-danger btn-sm ms-1">
                                    Cancel Admission
                                </button>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        </section>
    );
}
export default ConfirmIpAdmit;